import { LoaderCircle } from "lucide-react";
import { useVoltar } from "@/utils/voltar";
import { Button } from "./button";

type FormActionsProps = {
  loading?: boolean;
  onSave(): void;
  saveLabel?: string;
  // Sem permissão de alterar: só "Voltar"
  somenteLeitura?: boolean;
}

// Barra fixa no rodapé da página com as ações do formulário
export const FormActions = ({ loading, onSave, saveLabel = 'Salvar', somenteLeitura }: FormActionsProps) => {
  const voltar = useVoltar();
  return (
    <div className="sticky bottom-0 z-20 -mx-6 -mb-6 mt-2 flex justify-end gap-2 rounded-b-lg border-t bg-background/90 px-6 py-3 backdrop-blur">
      <Button type="button" variant="outline" onClick={() => voltar()}>{somenteLeitura ? 'Voltar' : 'Cancelar'}</Button>
      {!somenteLeitura && (
        <Button type="button" onClick={onSave} disabled={loading} className="min-w-24">
          {loading && <LoaderCircle className="mr-2 h-4 w-4 animate-spin" />}
          {saveLabel}
        </Button>
      )}
    </div>
  );
}
